export default "__VITE_ASSET__aVu9wxjJ__"